import { combineRootReducers } from '@tmapy/redux';
import { auth } from './reducer.js';
/**
 * @internal
 */
export const config = {
    auth: null,
    initialState: null,
};
export const configureAuth = (authConfig, initialState, reducer = auth) => {
    config.auth = authConfig;
    config.initialState = initialState;
    combineRootReducers({
        auth: reducer,
    });
};
//# sourceMappingURL=config.js.map